import { colors } from "../../common/styles";

export default {
    viewButton: {
        textTransform: "lowercase",
        ":hover": {
            textDecoration: "underline"
        }
    },
    circle: {
        height: 10,
        width: 10,
        backgroundColor: "#bbb",
        borderRadius: "50%",
        display: "inline-block"
    },
    primaryButton: {
        backgroundColor: "primary.main",
        color: colors.white,
        borderRadius: 32,
        px: 2,
        py: 1
    },
    hideFont: {
        fontSize: 0,
        "& svg": {
            color: "inherit"
        },
        "& .MuiBadge-root .MuiBadge-badge": {
            margin: "6px 0"
        }
    }
};
